import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b21db70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"10px 20px 20px"} }
const _hoisted_2 = { class: "goods-info-box" }
const _hoisted_3 = { class: "goods-name-box" }
const _hoisted_4 = {
  key: 0,
  class: "goods-sku-box"
}
const _hoisted_5 = {
  key: 0,
  class: "row-error"
}
const _hoisted_6 = { class: "summary-box" }
const _hoisted_7 = { class: "summary-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "店铺优惠（优惠券）", -1))
const _hoisted_9 = { class: "summary-value" }
const _hoisted_10 = { class: "summary-row" }
const _hoisted_11 = { class: "summary-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "运费", -1))
const _hoisted_13 = { class: "summary-value express-value" }
const _hoisted_14 = { class: "origin-tip" }
const _hoisted_15 = { class: "summary-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "应付金额", -1))
const _hoisted_17 = { class: "summary-value summary-total" }
const _hoisted_18 = { class: "inner-card-box" }
const _hoisted_19 = { class: "inner-card-right" }
const _hoisted_20 = { class: "align-right-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_dialog_title = _resolveComponent("ui-dialog-title")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ui_dialog_container = _resolveComponent("ui-dialog-container")!

  return (_openBlock(), _createBlock(_component_ui_dialog_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_ui_dialog_title, {
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reject', { msg: '关闭' }))),
        title: _ctx.title
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: _ctx.ruleForm,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ui_table, {
              data: _ctx.orderInfo.orderGoods,
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { align: "left" }, {
                  header: _withCtx(() => [
                    _createTextVNode("商品")
                  ]),
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, _toDisplayString(row.goodsDetails.name), 1),
                        (row.goodsDetails.skuName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(row.goodsDetails.skuName), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "price",
                  align: "center",
                  width: "90",
                  label: "单价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "num",
                  align: "center",
                  width: "60",
                  label: "数量"
                }),
                _createVNode(_component_el_table_column, {
                  label: "小计（元）",
                  width: "100",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.rowTotal(row)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "涨价或减价",
                  width: "200",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_input, {
                      modelValue: row.changeAmount,
                      "onUpdate:modelValue": ($event: any) => ((row.changeAmount) = $event),
                      placeholder: "0"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    (_ctx.rowError(row))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.rowError(row)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, "-" + _toDisplayString(_ctx.orderInfo.discountAmount || 0), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.expressAmount,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.expressAmount) = $event)),
                      style: {"width":"140px"}
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_14, "原 " + _toDisplayString(_ctx.orderInfo.originExpressAmount || 0), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.payAmount), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, " 收货地址：" + _toDisplayString(_ctx.orderInfo.province) + " " + _toDisplayString(_ctx.orderInfo.city) + " " + _toDisplayString(_ctx.orderInfo.county) + " " + _toDisplayString(_ctx.orderInfo.address), 1)
              ])
            ]),
            _createVNode(_component_el_form_item, { style: {"margin":"0"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.submitForm
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("改价")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}